import { FC, useCallback } from 'react';
import backBtnClass from '../../assets/scss/SubscriptionDetail/BackBtn.module.scss';

export const BackBtn: FC<{ clickBackBtnFunc: () => void }> = ({ clickBackBtnFunc }) => {
  const clickBackBtnHandler = useCallback(() => {
    clickBackBtnFunc();
  }, [clickBackBtnFunc]);

  return (
    <div className={backBtnClass.backBtnBox}>
      <button
        className={backBtnClass.backBtn}
        onClick={clickBackBtnHandler}
      >
        マイアカウントトップに戻る
      </button>
    </div>
  );
};
